import { ChangeEvent, FC, MouseEvent } from "react";

import { Grid } from "@mui/material";
import { MembershipValidityPeriod } from "@simplyk/common";
import { useFormContext, useWatch } from "react-hook-form";

import { useRateFieldName } from "../../hooks/useRateFieldName";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardCheckbox } from "@/dashboard-design-system/DashboardCheckbox/DashboardCheckbox";
import { DashboardInformationTooltip } from "@/dashboard-design-system/DashboardTooltip/DashboardInformationTooltip";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

const stopPropagation = (event: MouseEvent) => event.stopPropagation();

export const AutoRenewalCheckbox: FC = () => {
  const { t } = useTranslate();
  const { control, setValue } = useFormContext<StepTicketsFormData>();

  const autoRenewalField = useRateFieldName("allowAutomaticRenewal");
  const validityField = useRateFieldName("membershipValidityPeriod");
  const currentValidity = useWatch({ control, name: validityField });
  const allowAutomaticRenewal = useWatch({ control, name: autoRenewalField });

  const isVisible = [MembershipValidityPeriod.OneYearAfterPayment, MembershipValidityPeriod.AtDate].includes(
    currentValidity as MembershipValidityPeriod
  );

  if (!isVisible) {
    return null;
  }

  const handleChange = (_evt: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setValue(autoRenewalField, checked, { shouldDirty: true });
  };

  return (
    <Grid item xs={12} marginRight={2} paddingTop={1}>
      <DashboardCheckbox
        size="small"
        alignContent="center"
        checked={Boolean(allowAutomaticRenewal)}
        onChange={handleChange}
        label={
          <>
            {t("dashboard", "ticketing.renewalOptions.allowAutomaticRenewal")}
            <DashboardInformationTooltip
              onClick={stopPropagation}
              sx={{ marginLeft: 0.5 }}
              title={t("dashboard", "ticketing.renewalOptions.allowAutomaticRenewalHelp")}
              placement="top"
              alignOnText
            />
          </>
        }
      />
    </Grid>
  );
};
